// material-ui
import { Grid } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import SecondaryAction from 'ui-component/cards/CardSecondaryAction';
import { gridSpacing } from 'store/constant';

import { useState } from 'react';
import axios from 'axios';
import ApiLink from 'API';
import AgentListAndModify from './AgentListAndModify';
import { useNavigate } from 'react-router';
// ===============================|| COLOR BOX ||=============================== //

// ImageBox.propTypes = {
//     bgcolor: PropTypes.string,
//     title: PropTypes.string,
//     data: PropTypes.object.isRequired,
//     dark: PropTypes.bool
// };

// ===============================|| UI COLOR ||=============================== //

const Agent = () => {
    const [DataArray, setDataArray] = useState([]);
    const navigate = useNavigate();
    const [openBackdrop, setopenBackdrop] = useState(false);
    async function LoadData() {
        try {
            setopenBackdrop(true);
            const response = await axios.get(ApiLink + '/api/agents/^', {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                setDataArray(response.data);

                setopenBackdrop(false);
            } else if (response.status === 401) {
                //got to login and clear token
               
                localStorage.clear();
                 navigate(0);
            }
        } catch (error) {
            console.log(error);
             if (error.response.status === 401) {
                 localStorage.clear();
                 navigate(0);
             }
        }
    }
    return (
        <MainCard
            title="Agent Controller"
            // secondary={<SecondaryAction link="https://next.material-ui.com/system/palette/" />}
        >
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                  
                </Grid>
                <Grid item xs={12}>
                    <AgentListAndModify DataArray={DataArray} openBackdrop={openBackdrop} setopenBackdrop={setopenBackdrop} />
                </Grid>
                {/* <Grid item xs={12}>
                <SubCard title="Grey Color">
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <ColorBox bgcolor="grey.50" data={{ label: 'Grey-50', color: '#fafafa' }} title="grey[50]" dark />
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid> */}
            </Grid>
        </MainCard>
    );
};

export default Agent;
